<template>
    <div>
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="gsname" :label="$t('form_company')" >
                    <el-input  v-model="formData.gsname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="bmname" :label="$t('form_workshop_department')" >
                    <el-input  v-model="formData.bmname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="sqname" :label="$t('form_applicant')" >
                    <el-input  v-model="formData.sqname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="ckname" :label="$t('promanagement_storage_warehouse')" >
                    <el-input  v-model="formData.ckname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title num" prop="num" label="No:" >
                    <span  v-model="formData.num" style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.num}}</span>
                </el-form-item>
            </div>
            <div style="margin-bottom: 20px">
                <el-table class="table"
                          border
                          ref="multipleTable"
                          :data="tableData"
                          height="255"
                          size="mini"
                          :key="tableId"
                          :row-class-name="tableRowClassName"
                          tooltip-effect="dark">
                    <el-table-column
                            :label="$t('form_warehouse_number')"
                            align="left"
                            type="index"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_ingsname"
                            :label="$t('form_goods_rights_company')"
                            width=""
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_pzname"
                            :label="$t('form_product_name')"
                            show-overflow-tooltip>
                    </el-table-column>
                     <el-table-column
                             align="left"
                             prop="vc_no"
                             :label="$t('form_batch_number')"
                    width="200"
                             show-overflow-tooltip>
                     </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_unit"
                            :label="$t('form_metering')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="kcsl"
                            :label="$t('form_inventory_quantity')"
                            width=""
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            v-if="i_id!=0"
                            align="left"
                            prop="f_num"
                            :label="$t('promanagement_apply_for_inventory_quantity')"
                            width="110"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            v-if="i_id==0"
                            align="left"
                            prop="f_num"
                            :label="$t('promanagement_apply_for_inventory_quantity')"
                            width="110">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_num'" :rules="formRules.f_num">
                                <el-input-number :controls="false" :min="0" :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini" v-model="scope.row.f_num" @change="tlChange(scope.row,scope.$index)"></el-input-number>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="i_ischeck"
                            :label="$t('promanagement_warehousing_inspection')"
                            width="75"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <!--<el-checkbox v-model="scope.row.c_ischeck" :disabled="edit" true-label="1" false-label="0"></el-checkbox>-->
                            <div>{{scope.row.i_ischeck==1?$t('form_correct'):$t('form_deny')}}</div>
                        </template>
                    </el-table-column>
                    <!--卸货必检-->
                    <el-table-column
                            align="center"
                            prop="i_ismustcheck"
                            :label="$t('promanagement_unloading_must_be_inspected')"
                            width="75"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div>{{scope.row.i_ismustcheck==1?$t('form_correct'):$t('form_deny')}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="i_xtype"
                            :label="$t('promanagement_type')"
                            width="75"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div>{{scope.row.i_xtype==0?$t('promanagement_domestic_sales'):(scope.row.i_xtype==1?$t('promanagement_export'):(scope.row.i_xtype==2?$t('promanagement_e_commerce'):''))}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center"  width="50"  v-if="i_id==0">
                        <template slot="header" slot-scope="scope">
                            <el-popover
                                    class="pop"
                                    placement="bottom-end"
                                    width="1000"
                                    trigger="manual"
                                    v-model="visible">
                                <template>
                                    <product-details v-if="visible==true" :productDetails="productDetails" @closePop="closePop" @transValue="transValue"></product-details>
                                </template>
                                <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                            </el-popover
>
                        </template>
                        <template  slot-scope="scope">
                            <div class="iconminus">
                                <span class="minus" @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-form-item class="form-title" prop="vc_note" :label="$t('promanagement_on_duty_log')" >
                <el-input  v-model="formData.vc_note" >
                </el-input>
            </el-form-item>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_input_person')" >
                    <el-input  v-model="formData.vc_lruname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="date" :label="$t('form_enter_time')" >
                    <el-input  v-model="formData.date" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="date" :label="$t('promanagement_accountingTime')" >
                    <el-input  v-model="formData.dt_accounttime" disabled>
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center" v-if="!chakan">
            <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small">{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
            <!--            <el-button type="primary" @click="toApprove" v-if="state==0" :disabled="disabled" :class="baseerp+'btn'">提交审批</el-button>-->
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import ProductDetails from "./ProductDetails";
    export default {
        name: "PutinForm",
        components: {ProductDetails},
        props:{
            putinform:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                baseerp:"",
                formData:{
                    gsname:"",
                    sqname:"",
                    bmname:"",
                    ckname:"",
                    checked:false,
                    vc_note:"",
                    num:"000000",
                    vc_lruname:sessionStorage.getItem("lruname"),
                    date:"",
                    tableData:[],
                },
                formRules:{
                },
                tableData:[],
                visible:false,
                isbtn:false,
                productDetails:{},
                disabled:false,
                chakan:false,
                edit:false,
                i_id:0,//新增
                tableId:0,
                date:"",
                mid:0,
            }
        },
        watch: {
            putinform: {
                handler() {
                    if (this.putinform) {
                        this.pageSize=this.putinform.page_size;
                        this.i_id=this.putinform.i_id;
                        this.mid=this.putinform.i_mid;
                        if (this.putinform.i_id==0){
                            this.getDateYYYYMMddHHMMSS();
                            this.form=this.putinform.taskDa;
                            // console.log("this.form",this.form)
                            let dtnowtime = `${this.putinform.taskDa.dt_createtime.slice(0, 4)}-${this.putinform.taskDa.dt_createtime.slice(4, 6)}-${this.putinform.taskDa.dt_createtime.slice(6, 8)}`;
                            let dtendtime = `${this.putinform.taskDa.dt_endtime.slice(0, 4)}-${this.putinform.taskDa.dt_endtime.slice(4, 6)}-${this.putinform.taskDa.dt_endtime.slice(6, 8)} 23:59:59`;
                            this.productDetails=this.putinform.taskDa;
                            this.productDetails.i_mid=this.mid;
                            this.productDetails.selected=[];
                            this.edit=false;
                            this.chakan=false;
                            this.formData={
                                gsname:this.form.vc_gsname,
                                sqname:sessionStorage.getItem("lruname"),
                                ckname:this.form.vc_ckname,
                                date:this.date,
                                bmname:this.form.vc_cjname,
                                vc_note:'',
                                num:"000000",
                                vc_lruname:sessionStorage.getItem("lruname"),
                                tableData:[],
                                dt_accounttime:this.putinform.jz==false?dtendtime:dtnowtime,
                            };
                            // console.log( "this.feeding",this.formData);
                        }else {
                            /*if (this.feeding.title=="预览"){
                                this.chakan=true;
                            }else {
                                this.chakan=false;
                            }*/
                            //    编辑
                            this.edit=true;
                            this.isbtn=true;
                            this.editForm=this.putinform.value;
                            this.form=this.putinform.taskDa;
                            this.getWarehousingForm();
                        }
                        // console.log(this.putinform, "this.putinform",this.editForm);
                    }
                },
                immediate: true,
                deep: true
            }
        },
        mounted() {
            this.baseerp=baseerp;
        },
        methods: {
            async getWarehousingForm(){
                let param={
                    i_mid: this.mid,
                    i_pid:this.editForm.i_pid,
                }
                let res=await API.getWarehousingForm(param);
                if(res.code==1){
                    this.formData={
                        gsname:res.data.vc_ingsname,
                        sqname:res.data.vc_squname,
                        ckname:res.data.vc_inckname,
                        date:res.data.dt_createtime,
                        dt_accounttime:res.data.dt_accounttime,
                        bmname:res.data.vc_incjname,
                        vc_note:res.data.vc_note,
                        num:res.data.i_id,
                        vc_lruname:res.data.vc_lruname,
                        tableData:res.data.details,
                    };
                    this.tableData=res.data.details;
                    this.i_id=res.data.i_id;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            popShow(){
                this.visible=true
                //console.log(this.visible)
                if (this.visible==true){
                    this.isbtn=true
                }
            },
            closePop(){
                this.visible=false;
                this.isbtn=false;
            },
            tlChange(val,index){
                if (this.tableData[index].kcsl<val.f_num){
                    this.$message.error(this.$t('promanagement_the_incoming_quantity_shall_not_exceed_the_inventory_quantity'))
                    this.tableData[index].f_num=this.tableData[index].kcsl;
                }
                this.tableId=Math.random();
            },
            //产品列表
            transValue(value){
                /*let arr=[];
                if ( this.formData.tableData.length>0){

                }else {
                     arr=[...value];
                }*/
                let arr=[...this.tableData,...value];
                // console.log(value,"------------")

                //console.log(arr,"arrrrrrrrrrrrr")
                /*const vc_pzid='vc_pzid';
                const vc_no='vc_no';
                const i_scid='i_scid';
                //console.log(item,"--item--",next)
                const newArr = arr.reduce((all,next)=>all.some((item)=>item[vc_pzid]==next[vc_pzid])?all:[...all,next],[]);
                const newArr2 = newArr.reduce((all,next)=>all.some((item)=>item[vc_no]==next[vc_no])?all:[...all,next],[]);
                const newArr3 = newArr2.reduce((all,next)=>all.some((item)=>item[i_scid]==next[i_scid])?all:[...all,next],[]);

*/
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.vc_unique] ? '' : hash[next.vc_unique] = true && item.push(next);
                    return item
                }, []);
                this.formData.tableData=arr;
                this.tableData=arr;
                this.productDetails.selected=this.tableData;
                //console.log("**arr**",newArr3)
            },
            deleteRow(value,index){
                this.index=index;
                this.tableData.splice(this.index,1);
                // console.log(value,"-----")
            },
            cancel(){
                //console.log(this.pageSize,"------")
                this.visible=false;
                this.$emit('close');

                //this.$emit('getPickingReqList')
            },
            //保存
            async saveForm(){
                // console.log(this.tableData)
                let details = this.tableData.filter(item=>item.f_num!=0);
                if (details.length==0){
                    this.$message.error(this.$t('promanagement_please_add_inventory_products'));
                    return ;
                }
                this.disabled=true;
                let param={
                    i_mid: this.mid,
                    i_id:this.i_id,
                    i_rwid:this.form.i_id,
                    i_ingsid:this.form.i_gsid,
                    i_incjid:this.form.i_cjid,
                    i_inckid:this.form.i_ckid,
                    i_lruid:sessionStorage.getItem("userid"),
                    i_squid:sessionStorage.getItem("userid"),
                    vc_lruname:sessionStorage.getItem("lruname"),
                    vc_squname:sessionStorage.getItem("lruname"),
                    vc_note:this.formData.vc_note,
                    details:details,
                    dt_accounttime:this.formData.dt_accounttime,
                };
                let res=await API.saveWarehousing(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.visible=false;
                    this.$emit('getWarehousingList',this.pageSize)
                    // this.$emit('addLine',this.pageSize)
                    this.cancel();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.date=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
</style>